const pluginTabs = function(){

    const init = () => {

        const filters = document.querySelectorAll('.m-plugins__filter-item');
        const dropdown = document.querySelector('.m-plugins__filter-mobile select');

        dropdown.addEventListener("change", function() {
            filterTabs(dropdown.value);
        });

        [].map.call(filters, filter => {
            filter.addEventListener('click', () => filterTabs(filter.dataset.category));
        });

    };

    function filterTabs(data) {

        const tabs = document.querySelectorAll('.m-plugins__tab');
        const filters = document.querySelectorAll('.m-plugins__filter-item');

        [].map.call(filters, filter => {
            if(filter.classList.contains('m-plugins__filter-item--active')) {
                filter.classList.remove('m-plugins__filter-item--active');
            }

            if(filter.dataset.category == data) {
                filter.classList.add('m-plugins__filter-item--active');
            }
        });

        [].map.call(tabs, tab => {
            if(tab.classList.contains('m-plugins__tab--active')) {
                tab.classList.remove('m-plugins__tab--active');
            }

            if(tab.dataset.category == data) {
                tab.classList.add('m-plugins__tab--active');
            }
        });
    }


    return {
      init,
    }
}();

if(document.querySelectorAll('.m-plugins__tab').length){
    pluginTabs.init();
}